import { render, staticRenderFns } from "./GenerateCardsForm.vue?vue&type=template&id=cb8554e6&"
import script from "./GenerateCardsForm.vue?vue&type=script&lang=js&"
export * from "./GenerateCardsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports